<script setup lang="ts"></script>

<template>
  <div class="flex flex-col w-full">
    <h2 class="font-bold text-body-1 mb-2">
      <slot name="label">
        <BaseSkeleton class="h-[20px] w-[130px]" />
      </slot>
    </h2>
    <div class="flex flex-row flex-wrap gap-1" v-auto-animate>
      <slot name="words">
        <span v-for="j in 15" :key="j">
          <BaseSkeleton class="h-[20px] w-[80px]" />
        </span>
      </slot>
    </div>
  </div>
</template>

<style scoped></style>
